import React, { Fragment } from 'react';
import { showNotification } from './../../../utils';
import SelectField from './../Form/SelectField';
import numeral from 'numeral';

const Form = React.memo((props) => {
    if (props.promotionalItem == null) {
        return null;
    }

    const continueHandler = (type = 1) => {
        if (props.quantity === '' || props.logo === '') {
            return showNotification('Complete Information', 'Complete all the required fields to continue', 'info');
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, props.isMyuth, type);
        } else {
            props.addToCart(2, props.history, props.isMyuth, type);
        }
    };

    const quantityOptions = [{ value: '', label: 'Select option' }];
    for (let i = 1; i <= 10; i++) {
        if (parseInt(props.promotionalItem.pricing_enabled[i - 1]) === 0) {
            continue;
        }

        if (parseInt(props.promotionalItem.is_bundles)) {
            let bundleName = i > 1 ? 'bundles' : 'bundle';
            quantityOptions.push({
                value: i,
                label: i + ' ' + bundleName + ' (' + (i * props.promotionalItem.pieces_per_bundle) + ' pieces)',
            });
        } else {
            quantityOptions.push({
                value: i,
                label: i,
            });
        }
    }

    let logoOptions = [{ value: '', label: 'Select option' }];
    if (parseInt(props.promotionalItem.show_logos) === 1) {
        logoOptions.push({ value: '1', label: 'UT Physicians' });
    } else if (parseInt(props.promotionalItem.show_logos) === 2) {
        logoOptions.push({ value: '2', label: 'UTHealth Houston' });
    } else if (parseInt(props.promotionalItem.show_logos) === 3) {
        logoOptions.push({ value: '2', label: 'UTHealth Houston' });
        logoOptions.push({ value: '3', label: 'Heart and Vascular' });
        logoOptions.push({ value: '4', label: 'Cizik School of Nursing' });
        logoOptions.push({ value: '5', label: 'McGovern Medical School' });
        logoOptions.push({ value: '6', label: 'School of Biomedical Informatics' });
        logoOptions.push({ value: '7', label: 'School of Dentistry' });
        logoOptions.push({ value: '8', label: 'School of Public Health' });
        // logoOptions.push({ value: '9', label: 'UTHealth Houston General' });
        // logoOptions.push({ value: '10', label: 'School of Public Health - Austin' });
        // logoOptions.push({ value: '11', label: 'School of Public Health - Brownsville' });
        // logoOptions.push({ value: '12', label: 'School of Public Health - Dallas' });
        // logoOptions.push({ value: '13', label: 'School of Public Health - El Paso' });
        // logoOptions.push({ value: '14', label: 'School of Public Health - San Antonio' });
        logoOptions.push({ value: '16', label: 'McWilliams School of Biomedical Informatics' });
        logoOptions.push({ value: '15', label: 'UTHealth Houston Children\'s Heart Institute' });
    }

    let bullet1 = null;
    if (props.promotionalItem.bullet1) {
        bullet1 = <li>{props.promotionalItem.bullet1}</li>;
    }

    let bullet2 = null;
    if (props.promotionalItem.bullet2) {
        bullet2 = <li>{props.promotionalItem.bullet2}</li>;
    }

    let bullet3 = null;
    if (props.promotionalItem.bullet3) {
        bullet3 = <li>{props.promotionalItem.bullet3}</li>;
    }

    let bullet4 = null;
    if (props.promotionalItem.bullet4) {
        bullet4 = <li>{props.promotionalItem.bullet4}</li>;
    }

    let bullet5 = null;
    if (props.promotionalItem.bullet5) {
        bullet5 = <li>{props.promotionalItem.bullet5}</li>;
    }

    let bullet6 = null;
    if (props.promotionalItem.bullet6) {
        bullet6 = <li>{props.promotionalItem.bullet6}</li>;
    }

    let bullet7 = null;
    if (props.promotionalItem.bullet7) {
        bullet7 = <li>{props.promotionalItem.bullet7}</li>;
    }

    let bullet8 = null;
    if (props.promotionalItem.bullet8) {
        bullet8 = <li>{props.promotionalItem.bullet8}</li>;
    }

    let bullet9 = null;
    if (props.promotionalItem.bullet9) {
        bullet9 = <li>{props.promotionalItem.bullet9}</li>;
    }

    let bullet10 = null;
    if (props.promotionalItem.bullet10) {
        bullet10 = <li>{props.promotionalItem.bullet10}</li>;
    }

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let buttonsContainer = null;
    if (props.isMyuth && parseInt(props.isMyuth) === 1) {
        let shoppingCartButton = <button type="button" className="add-to-cart" disabled={props.addingToCart} onClick={continueHandler.bind(this, 1)}>{buttonLabel}</button>;
        if (props.action === 'edit') {
            shoppingCartButton = null;
        }

        buttonsContainer = (
            <div className="buttons-container">
                <button type="button" className="save-work" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                {shoppingCartButton}
            </div>
        );
    } else {
        let shoppingCartButton = <button type="button" className="continue" onClick={continueHandler.bind(this, 1)} disabled={props.addingToCart}>{buttonLabel}</button>;
        if (props.action === 'edit') {
            shoppingCartButton = null;
        }

        buttonsContainer = (
            <div className="text-center">
                <div>
                    <button type="button" className="save-work" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                    {shoppingCartButton}
                </div>
            </div>
        );
    }

    const renderPricing = () => {
        if (props.promotionalItem == null) {
            return null;
        }

        let rows = [];
        for (let i = 1; i <= 10; i++) {
            if (parseInt(props.promotionalItem.pricing_enabled[i - 1]) === 0) {
                continue;
            }

            let totalQuantity = i;
            let quantityLabel = i;
            if (parseInt(props.promotionalItem.is_bundles) === 1) {
                let bundleName = i === 1 ? 'bundle' : 'bundles';
                quantityLabel = i + ' ' + bundleName + ' (' + numeral(i * props.promotionalItem.pieces_per_bundle).format('0,0') + ' pieces)';
                totalQuantity = i * props.promotionalItem.pieces_per_bundle;
            }

            rows.push(
                <tr>
                    <td>{quantityLabel}</td>
                    <td className="text-right">{numeral(props.promotionalItem.pricing[i - 1]).format('$0,0.00')}</td>
                    <td className="text-right">{numeral(props.promotionalItem.pricing[i - 1] / totalQuantity).format('$0,0.00')}</td>
                </tr>
            );
        }
        return rows;
    };

    let favoriteClasses = ['favorite-container'];
    let favoriteIcon = <i className="far fa-heart empty-heart" />;
    if (props.isFavorite) {
        favoriteClasses.push('active');
        favoriteIcon = <i className="fas fa-heart filled-heart" />
    }

    const handleAddFavorite = () => {
        props.addFavorite(props.history);
    };

    let logoField = (
        <SelectField
            required
            label="Logo"
            value={props.logo}
            setFunction={props.setLogo}
            options={logoOptions}
        />
    )
    if (parseInt(props.templateId) === 16) {
        logoField = null;
    }

    return (
        <div className="form-container">
            <h5>Variables</h5>
            <div className={favoriteClasses.join(' ')} onClick={handleAddFavorite}>
                {favoriteIcon} Favorites
            </div>
            <form action="">
                <hr />
                <SelectField
                    required
                    label="Quantity"
                    value={props.quantity}
                    setFunction={props.setQuantity}
                    options={quantityOptions}
                />
                {logoField}
                <hr />
                <h5 className="description-header">Description</h5>
                <div className="description-section">
                    <div><span className="label">Title:</span> {props.promotionalItem.name}</div>
                    <div className="description-list">
                        <span className="label">Description:</span> {props.promotionalItem.description}
                        <ul>
                            {bullet1}
                            {bullet2}
                            {bullet3}
                            {bullet4}
                            {bullet5}
                            {bullet6}
                            {bullet7}
                            {bullet8}
                            {bullet9}
                            {bullet10}
                        </ul>
                    </div>
                </div>
            </form>
            {buttonsContainer}
            <h5>Pricing</h5>
            <div className="pricing-container">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Quantity</th>
                            <th className="text-right">Price</th>
                            <th className="text-right">Each</th>
                        </tr>
                    </thead>
                    <tbody>{renderPricing()}</tbody>
                </table>
            </div>
        </div>
    );
});

export default Form;
